const SideNav = {
  init() {
    this.events();
    this.anchor();
  },

  events() {
    $('.side-nav__toggle').on('click', this.toggle);
    $('.side-nav__link a').on('click', this.handleClick);

    $('.nav-anchor__nav .prev').on('click', this.handlePrev);
    $('.nav-anchor__nav .next').on('click', this.handleNext);

    // $(document).on('scroll', this.scroll);
  },

  handleClick(e) {
    const btnEL = $(e.currentTarget);
    const href = btnEL.attr('href');

    if (!href.startsWith('#')) {
      return;
    }

    e.preventDefault();

    $('.nav-anchor').removeClass('visible');

    $('.side-nav__item').removeClass('active');
    btnEL.closest('.side-nav__item').addClass('active');

    SideNav.scrollToEl(href);
  },

  handlePrev() {
    let currEl = $('.side-nav__item.active');
    if (!currEl.length) {
      currEl = $('.side-nav__item').first()
    }
    const prevEl = currEl.prev();

    if (!prevEl.length) {
      return;
    }

    currEl.removeClass('active');
    prevEl.addClass('active');

    let href = prevEl.find('a').attr('href');
    const id = prevEl.find('a').data('id');
    if (id) {
      href = `#${id}`;
    } else {
      if (!href.startsWith('#')) {
        window.location = href;
      }
    }

    SideNav.scrollToEl(href);
  },

  handleNext() {
    let currEl = $('.side-nav__item.active');
    if (!currEl.length) {
      currEl = $('.side-nav__item').first()
    }
    const nextEl = currEl.next();

    if (!nextEl.length) {
      return;
    }

    currEl.removeClass('active');
    nextEl.addClass('active');

    let href = nextEl.find('a').attr('href');
    const id = nextEl.find('a').data('id');
    if (id) {
      href = `#${id}`;
    } else {
      if (!href.startsWith('#')) {
        window.location = href;
      }
    }

    SideNav.scrollToEl(href);
  },

  scrollToEl(target) {
    if (!$(target).length) {
      return;
    }

    $('html,body').animate({
      scrollTop: $(target).offset().top - 150
    })
  },

  anchor() {
    $('.nav-anchor__toggle').on('click', () => {
      $('.nav-anchor').addClass('visible');
    });
    $('.nav-anchor__close').on('click', () => {
      $('.nav-anchor').removeClass('visible');
    });
  },

  toggle(e) {
    const wrapperEl = $(e.currentTarget).closest('.side-nav__item');

    if (wrapperEl.hasClass('active')) {
      wrapperEl.children('ul').slideUp();
      wrapperEl.removeClass('active');
    } else {
      wrapperEl.children('ul').slideDown();
      wrapperEl.addClass('active');
    }
  }
}

export default SideNav;
